// Mock data for Football Academy Landing Page

export const heroData = {
  title: "English Language Learning + High-Performance Football Camp in the UK 2026",
  subtitle: "Train with top European coaches while mastering English at England's premier football academy",
  backgroundImage: "https://images.pexels.com/photos/35246937/pexels-photo-35246937.jpeg",
  ctaButtons: [
    { text: "Get a Quote", type: "primary" },
    { text: "Download Brochure", type: "secondary" }
  ]
};

export const overviewData = {
  description: "The English + High-Performance Football Summer Camp in England takes place at a private school located in Oakham, a small town north of London, conveniently situated within easy reach of the main airports.",
  highlights: [
    "Improve your English in a short period of time by learning from experienced professionals",
    "Combine classroom learning with language acquisition through sport",
    "Prepare for the football season to perform at your best with your club",
    "Train at a top football academy with professional coaches"
  ],
  duration: "1, 2, 3, or 4 weeks during July",
  ageRange: "11-17 years old",
  gender: "Boys only"
};

export const programFeatures = [
  {
    icon: "Users",
    title: "Ages 11-17",
    description: "Boys only program",
    category: "Participants"
  },
  {
    icon: "Zap",
    title: "Intensity 4.5/5",
    description: "High-performance training",
    category: "Training Level"
  },
  {
    icon: "Award",
    title: "UEFA Licensed",
    description: "Top European coaches",
    category: "Coaches"
  },
  {
    icon: "Home",
    title: "Oakham School",
    description: "Premium accommodation",
    category: "Residence"
  },
  {
    icon: "Globe",
    title: "English Immersion",
    description: "4.5 hours daily classes",
    category: "Language"
  },
  {
    icon: "Shield",
    title: "24/7 Security",
    description: "Safe environment",
    category: "Safety"
  }
];

// Clinic Program Images
export const clinicImages = {
  hero: "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/u1ufrmmp_e2f9c48e-9392-4201-956e-863fc8ed1b67.webp",
  gallery: [
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/o8wm1uoq_Academy_Camp_2025-322.jpg",
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/8jllshpw_Generales%20%2851%29.jpg",
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/ejclf7bg_Generales%20%2847%29.jpg",
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/9ms5m8vk_Generales%20%288%29.jpg"
  ]
};

export const testimonials = [
  {
    name: "Brenda",
    role: "Mother of Jerónimo C. G., 15 years old",
    country: "Spain",
    text: "Everything was great. My son was very happy spending time there and learning. To sum it up in one word: excellent. I think the camp has everything the kids need to be happy – learning and enjoying themselves.",
    rating: 5
  },
  {
    name: "Nouf",
    role: "Father of Zayed A., 13 years old",
    country: "United Kingdom",
    text: "A great experience, a fast response, quick, and professional. Eduard the supervisor at the camp was very supportive and helpful.",
    rating: 5
  },
  {
    name: "Dolores",
    role: "Mother of Oriol N. P., 18 years old",
    country: "Spain",
    text: "The experience was amazing! We definitely plan to return, and if it were up to our son, he would stay all year round! 10 out of 10!",
    rating: 5
  },
  {
    name: "Giuliana T.",
    role: "Mother of Riccardo Z., 17 years old",
    country: "Italy",
    text: "It was a wonderful experience for Riccardo, he met a lot of people and was able to speak many languages with people from different European countries.",
    rating: 5
  },
  {
    name: "Clara",
    role: "Mother of Marc G. O., 18 years old",
    country: "Spain",
    text: "Overall it was a great experience and we would highly recommend it. Our congratulations for the excellent organization.",
    rating: 5
  },
  {
    name: "Lorenzo P.",
    role: "Father of Lorenzo S. P., 15 years old",
    country: "Italy",
    text: "A great experience, just what we were looking for. Thanks for everything.",
    rating: 5
  }
];

export const trainingData = {
  description: "Professional-style training designed for advanced/elite players with solid technique and advanced game intelligence.",
  features: [
    "2 training sessions per day in English",
    "Individual and group tactical exercises",
    "Personalized coaching and feedback",
    "Goalkeeper specialized training",
    "Strength and conditioning sessions",
    "Nutritional guidance for athletes",
    "Video analysis workshops",
    "Trial matches with local teams",
    "Final evaluation report"
  ],
  intensity: "4.5/5",
  playerLevel: "Intermediate to Advanced",
  studentsPerGroup: 15
};

export const academies = [
  {
    name: "Steven Gerrard High Performance Academy",
    country: "UK",
    logo: "SG",
    highlights: [
      "More than 10 years experience and 1,000+ graduates",
      "Linked to semi-professional teams in Liverpool",
      "Locations in Liverpool and Alicante, Spain"
    ],
    successStories: [
      "Jack Hazlehurst – City of Liverpool FC",
      "John McGrath – City of Liverpool FC"
    ]
  },
  {
    name: "Brooke House College",
    country: "UK",
    logo: "BH",
    highlights: [
      "Elite training facilities",
      "Fantastic academic excellence program",
      "Top international players from national youth teams"
    ],
    successStories: [
      "Jesse Sekidika – Galatasaray F.C.",
      "Lazar Boyanov – C.D. Nacional",
      "Kelvin John – KRC GENK"
    ]
  },
  {
    name: "Dubai City Academy",
    country: "Dubai",
    logo: "DC",
    highlights: [
      "Experienced coaching staff from top English clubs",
      "Opportunity to play in professional leagues in Dubai",
      "Top facilities in magnificent climate"
    ],
    successStories: [
      "Adli Mohamed – Southampton FC",
      "Max Ek – Djurgarden FC",
      "Raja Asfour – Lebanon U17 National Squad"
    ]
  },
  {
    name: "IDA International",
    country: "UK, Spain, Italy, USA",
    logo: "IDA",
    highlights: [
      "Four countries with ability to combine destinations",
      "Highly competitive training methodology",
      "Extensive experience in tournaments and training"
    ],
    successStories: [
      "Jeremy de León – Puerto Rico U20",
      "Kyah Le – Res Roma and Gonzaga",
      "Jameson Mannix – University of Hamilton"
    ]
  }
];

export const scheduleData = {
  dailySchedule: [
    { time: "7:00", activity: "Wake up" },
    { time: "7:30", activity: "Breakfast preparation" },
    { time: "8:00", activity: "Breakfast" },
    { time: "9:00", activity: "English lessons or time in facilities" },
    { time: "12:00", activity: "First training session" },
    { time: "13:00", activity: "Lunch" },
    { time: "15:00", activity: "Second training session" },
    { time: "18:00", activity: "Dinner preparation" },
    { time: "18:30", activity: "Dinner" },
    { time: "19:30", activity: "Rest time" },
    { time: "20:00", activity: "Soccer presentation" },
    { time: "21:00", activity: "Break" },
    { time: "22:00", activity: "Lights out" }
  ],
  excursions: "Visit to an iconic London stadium (Wembley Stadium in 2024 edition)"
};

export const accommodationData = {
  name: "Oakham School",
  location: "Two hours north of London",
  roomTypes: "Shared rooms (double or triple), limited single rooms",
  bathrooms: "Shared",
  amenities: [
    "Games room with pool table and ping-pong",
    "PlayStation and TV lounge",
    "Full gymnasium access",
    "Olympic-size swimming pool",
    "Room cleaning service",
    "Linen and towel change",
    "Free WiFi"
  ],
  walkingDistance: "5-10 minutes to sports facilities"
};

export const pricingData = [
  {
    duration: "1 Week",
    price: "£1,895",
    features: [
      "Full board accommodation",
      "2 daily training sessions",
      "English lessons (4.5hrs/day)",
      "All activities included",
      "Sports facilities access"
    ]
  },
  {
    duration: "2 Weeks",
    price: "£3,195",
    features: [
      "Full board accommodation",
      "2 daily training sessions",
      "English lessons (4.5hrs/day)",
      "All activities included",
      "Sports facilities access",
      "Stadium excursion"
    ],
    popular: true
  },
  {
    duration: "3 Weeks",
    price: "£5,345",
    features: [
      "Full board accommodation",
      "2 daily training sessions",
      "English lessons (4.5hrs/day)",
      "All activities included",
      "Sports facilities access",
      "Stadium excursion",
      "Extended evaluation report"
    ]
  },
  {
    duration: "4 Weeks",
    price: "£6,149",
    features: [
      "Full board accommodation",
      "2 daily training sessions",
      "English lessons (4.5hrs/day)",
      "All activities included",
      "Sports facilities access",
      "Stadium excursion",
      "Comprehensive evaluation",
      "Certificate of completion"
    ]
  }
];

export const galleryImages = [
  "https://images.pexels.com/photos/35246937/pexels-photo-35246937.jpeg",
  "https://images.pexels.com/photos/35205020/pexels-photo-35205020.jpeg",
  "https://images.pexels.com/photos/35246915/pexels-photo-35246915.jpeg"
];

export const startDates = [
  { date: "June 29, 2026", available: true },
  { date: "July 6, 2026", available: true },
  { date: "July 13, 2026", available: true },
  { date: "July 20, 2026", available: true }
];